import { useQuery, UseQueryOptions } from 'react-query';

import { AutoRedirectResponse, LandingApi } from 'api/LandingApi';
import { prelandIdFormPathname } from 'helpers/route';

const AUTO_REDIRECT_QUERY_KEY = 'auto-redirect-query';

export const useAutoRedirectQuery = (
  queryOptions?: UseQueryOptions<AutoRedirectResponse>
) => {
  return useQuery<AutoRedirectResponse>(
    AUTO_REDIRECT_QUERY_KEY,
    () =>
      LandingApi.fetchAutoRedirectData(
        prelandIdFormPathname(document.location.pathname)
      ),
    {
      retry: false,
      cacheTime: 0,
      ...queryOptions,
    }
  );
};
